import type { liveInputInsightsActionPayload } from '@app/types'
import { liveInputEvents } from '../constants'
import { v4 as generateUuid } from 'uuid'
import { filterDefinitions } from '@app/insights/filter-definitions'
import { onNextPageTeardown } from '@app/adapters/page-teardown'
import {
  comparisonModes,
  filters as filterTypes,
} from '@app/insights/constants'

export default (): void => {
  const handleEvent = (payload: liveInputInsightsActionPayload): void => {
    const reconciliationResultFilterDefinition = filterDefinitions.find(
      (filter) => filter.type === filterTypes.RECONCILIATION_RESULT
    )

    const followCompaniesFilterDefinition = filterDefinitions.find(
      (filter) => filter.type === filterTypes.FOLLOW_COMPANIES
    )

    if (
      !reconciliationResultFilterDefinition ||
      !followCompaniesFilterDefinition
    ) {
      return
    }

    const reconciliationResultFilter = {
      type: filterTypes.RECONCILIATION_RESULT,
      params: reconciliationResultFilterDefinition.serializeSettings({
        comparisonMode: comparisonModes.SHOW_ALL,
        comparisonValue: '',
        reconciliationTextId: payload.reconciliationTextId,
        identifier: payload.liquidPath,
      }),
      uuid: generateUuid(),
    }

    const followCompaniesFilter = {
      type: filterTypes.FOLLOW_COMPANIES,
      params: followCompaniesFilterDefinition.serializeSettings({
        comparisonMode: comparisonModes.CURRENT_USER,
      }),
      uuid: generateUuid(),
    }

    const filters = [reconciliationResultFilter, followCompaniesFilter]

    const url = window.Silverfin.Routes.companies_overview_index_path({
      firm_id: window.Silverfin.currentFirmId,
      filters: JSON.stringify(filters),
      openFilterModal: reconciliationResultFilter.uuid,
      period_date: payload.periodDate,
      period_selection: 'accounting_period',
    })

    window.open(url, '_blank')
  }

  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      "[data-behaviour='insights-link']"
    ) as HTMLElement

    if (element) {
      window.eventHub.$on(liveInputEvents.INSIGHTS_ACTION_CLICKED, handleEvent)
    }
  })

  onNextPageTeardown(() =>
    window.eventHub.$off(liveInputEvents.INSIGHTS_ACTION_CLICKED)
  )
}
